import React from 'react';
import { withSearch, WithSearchProps } from '@elastic/react-search-ui';

interface Props {
  className?: string;
}
const FilterSummaryComponent: React.FC<WithSearchProps & Props> = ({ filters, className }) => {
  console.log('FilterSummary', filters);
  const totalSelected = filters?.reduce((count, filter) => count + filter.values.length, 0);
  return (
    <div className={className || 'job-filter-counter'}>
      <span className="job-filter-counter--number">
        Filters{totalSelected > 0 ? ` (${totalSelected})` : ''}
      </span>
      {totalSelected > 0 && (
        <span className="job-filter-counter--button">
          <a
            className="tertiary-info erase-trace"
            href={window.aqJobsOptions?.relativeListingUrl || '/find-work'}
          >
            Clear all
          </a>
        </span>
      )}
    </div>
  );
};
const FilterSummary = withSearch(({ filters }) => ({ filters }))(FilterSummaryComponent);
export default FilterSummary;
